import type { PassedCourseExpanded } from "@brookbush/types";

import { useAuth } from "@clerk/nextjs";
import useSWR from "swr";

const usePassedCourses = () => {
	const { isSignedIn } = useAuth();
	const { data: passedCourses, ...rest } = useSWR<PassedCourseExpanded[]>(
		isSignedIn && `/courses/passed`,
		{
			errorRetryCount: 0,
		},
	);

	const isCoursePassed = (courseId: string) => {
		return passedCourses?.find((course) => course.courseId === courseId);
	};

	return {
		passedCourses,
		isCoursePassed,
		isLoadingPassedCourses: rest.isLoading,
		...rest,
	};
};

export default usePassedCourses;
